import { SxProps, Theme } from '@mui/material';

// Container principal da tela
export const loginContainer: SxProps<Theme> = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#d3d3d3',
};

// Estilo do Card ou Paper principal
export const paperStyle: SxProps<Theme> = {
  width: 500,
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '10px 10px 5px rgba(0, 0, 0, 0.4)',
};

// Seção superior: Logo e título (fundo branco)
export const upperSection: SxProps<Theme> = {
  backgroundColor: '#fff',
  padding: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

// Container para a logo e o título
export const logoAndTitleContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
};

// Estilo da imagem (Logo)
export const logoStyle: React.CSSProperties = {
  width: '100px',
  height: '100px',
  marginRight: '12px', // Espaço entre a logo e o título
  objectFit: 'contain',
};

export const logoStyleGDU: React.CSSProperties = {
  width: '140px',
  height: '140px',
  marginRight: '80px', // Espaço entre a logo e o título
  objectFit: 'contain',
};

export const logoStyleGDU2: React.CSSProperties = {
  width: '120px',
  height: '120px',
  marginTop: '10px', // Espaço entre a logo e o título
  objectFit: 'contain',
};

// Container para o título centralizado
export const titleContainer: SxProps<Theme> = {
  flex: 1, // Faz com que o título ocupe o espaço restante
  display: 'flex',
  justifyContent: 'center', // Centraliza horizontalmente
  alignItems: 'center', // Centraliza verticalmente
};

// Estilo do container do botão
export const buttonContainer: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '16px',
};

// Seção inferior: Inputs e botão (fundo cinza)
export const lowerSection: SxProps<Theme> = {
  backgroundColor: '#f0f0f0',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

// Estilo do botão pequeno
export const smallButtonStyle: SxProps<Theme> = {
  width: '230px', // comprimento do botão
  height: '29px', // largura do botão
};

